import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'shared-svg',
  templateUrl: './shared-svg.component.html',
  styleUrls: ['../../svg.scss']
})
export class SharedSvgComponent {
  @Input() active:boolean=false;
  constructor() { }
}
